import React, { useEffect, useState } from 'react';
import { MdArrowBackIos, MdClose, MdOutlineClose } from 'react-icons/md';
import Modal from 'react-responsive-modal';
import PersonalTags from './PersonalTags';
import { useMutation, useQuery } from '@apollo/client';
import { GET_TAGS } from '../../apollo/Queries';
import { useDispatch, useSelector } from 'react-redux';
import { CREATE_UPDATE_TAG, TAG_INTO_FILE } from '../../apollo/Mutations';
import toast from 'react-hot-toast';
import { setPopup } from '../../redux/messageSlice';
import CreateTag from '../Admin/SharedTeamTags/CreateTag';

const TagsPopup = ({ type, tag_list = [], setTag_list, setTagsPopup, upload_type = '', ...otherProps }) => {
    const dispatch = useDispatch();
    const { user, active_file } = useSelector(state => state.message);
    const [tab_state] = useState('public');
    const [inputVal, setInputVal] = useState('');
    const [createTagsPopup, setCreateTagsPopup] = useState(false);
    const [all_tags, setAll_tags] = useState([]);
    const [selected_ids, setSelected_ids] = useState([]);
    const [edit_title, setEdit_title] = useState('');
    const [tagEditInput, setTagEditInput] = useState('');
    const [src_string, setSrc_string] = useState('');
    const [loader, setloader] = useState(true)
    const [btnloader, setBtnloader] = useState(true)
    const [old_ids, setOld_ids] = useState([]);
    const [changesMade, setChangesMade] = useState(false);

    useQuery(GET_TAGS, {
        variables: { company_id: user?.company_id, upload_type: upload_type },
        fetchPolicy: 'no-cache',
        onCompleted: (res) => {
            if (res) {
                let tags = [...res.tags.private, ...res.tags.public, ...res.tags.task_tag]
                let taskTag = otherProps.from === '#TASK' ? res.tags.task_tag.filter(f => f.title === otherProps.from) : res.tags.task_tag;
                setAll_tags(tags)
                if (tag_list?.length > 0) {
                    setSelected_ids(tag_list.map(m => m.tag_id))
                }
                if (type === 'file') {
                    let old_tag = active_file?.tag_list || []
                    let taskTagIds = taskTag.map(m => m.tag_id);
                    if (old_tag.filter(f => taskTagIds.indexOf(f) > -1).length > 0) {
                        setSelected_ids([...old_tag])
                        setOld_ids([...old_tag])
                    } else {
                        setSelected_ids([...taskTagIds, ...old_tag])
                        setOld_ids([...taskTagIds, ...old_tag])
                    }
                }
            }
            setloader(false)
        },
        onError: (error) => {
            console.log("🚀 ~ SharedTeamTags ~ error:", error)
        }
    });

    useEffect(() => {
        if (JSON.stringify(old_ids) !== JSON.stringify(selected_ids)) {
            setChangesMade(true);
        } else {
            setChangesMade(false);
        }
    }, [old_ids, selected_ids])

    const select_tag = (tag) => {
        setSelected_ids([...selected_ids, tag.tag_id])
    }

    const [create_update] = useMutation(CREATE_UPDATE_TAG)

    const updateTagTitle = async (e, d) => {
        setBtnloader(true)
        if (!d && src_string.trim() !== '' && !btnloader) {
            try {
                let json = {
                    title: src_string.toUpperCase(),
                    tag_id: '',
                    tagged_by: user?.id,
                    tag_type: "public",
                    tag_color: "#e82a87",
                    team_list: []
                }

                let { data } = await create_update({ variables: { input: json } });

                setSrc_string('')
                setAll_tags([data.create_update_tag.tag, ...all_tags])
                select_tag(data.create_update_tag.tag)
            } catch (error) {
                console.log("🚀 ~ updateTagTitle ~ error:", error)
            }
        } else {

            if (e.keyCode === 13 && edit_title.trim() !== '') {
                try {
                    let data = {
                        title: edit_title.trim().toUpperCase(),
                        tag_id: d.tag_id,
                        tagged_by: d.tagged_by,
                        tag_type: d.tag_type,
                        tag_color: d.tag_color,
                        team_list: d.team_list
                    }
                    let apires = await create_update({ variables: { input: data } });
                    if (apires?.data?.create_update_tag?.status) {
                        toast.success(apires?.data?.create_update_tag?.message)
                        setAll_tags(all_tags.map(v => v.tag_id === d.tag_id ? { ...apires?.data?.create_update_tag.tag } : v))
                        setTagEditInput('')
                    } else {
                        toast.error(apires?.data?.create_update_tag?.message)
                    }
                } catch (error) {
                    console.log("🚀 ~ updateTagTitle ~ error:", error)
                }
            }
        }
        setBtnloader(false)
    }

    const [tag_into_file] = useMutation(TAG_INTO_FILE)

    const removeKey = (arry, keyToRemove) => {
        return arry.map(obj => {
            const { [keyToRemove]: _, ...rest } = obj; // Destructure the object, excluding the specified key
            return rest; // Return the modified object without the specified key
        });
    };

    const update_file_tag = () => {
        try {
            let old_tag = active_file?.tag_list || []
            let a_ids = selected_ids.filter((i) => old_tag.indexOf(i) === -1);
            let r_ids = old_tag.filter((i) => selected_ids.indexOf(i) === -1);
            let a_data = all_tags.filter((i) => selected_ids.indexOf(i.tag_id) > -1 && old_tag.indexOf(i.tag_id) === -1);
            let r_data = all_tags.filter((i) => selected_ids.indexOf(i.tag_id) === -1 && old_tag.indexOf(i.tag_id) > -1);

            tag_into_file({
                variables: {
                    input: {
                        conversation_id: active_file?.conversation_id,
                        msg_id: active_file?.msg_id,
                        file_id: active_file?.id,
                        is_reply: active_file.main_msg_id ? 'yes' : 'no',
                        participants: active_file?.participants,
                        newtag: a_ids,
                        removetag: r_ids,
                        newtag_tag_data: removeKey(a_data, '__typename'),
                        removetag_tag_data: removeKey(r_data, '__typename'),
                    }
                }
            })
            dispatch(setPopup({ key: 'tag_popup', value: false }));
        } catch (error) {
            console.log("🚀 ~ TagPopup ~ error:", error)
        }
        // setChangesMade(true);
    }

    const submit_tag = async () => {
        switch (type) {
            case 'create_room':
                setTag_list(all_tags.filter(f => selected_ids.includes(f.tag_id)))
                setTagsPopup(false)
                break;
            case 'file':
                update_file_tag()
                break;
            case 'update_room':
                // otherProps.setTag_list(miniList)
                // Navigate(-1)
                setTag_list(all_tags.filter(f => selected_ids.includes(f.tag_id)))
                setTagsPopup(false)
                break;
            default:
                break;
        }
    }

    const closePopup = () => {
        if (type === 'file') {
            dispatch(setPopup({ key: 'tag_popup', value: false }))
        } else {
            setTagsPopup(false)
        }
    }

    const filteredTags = all_tags
        .filter(f => f.title !== '#TASK-COST' && f.title !== '#TASK' && f.title !== 'UNTAGGED FILES')
        .filter(f => f.title.toLowerCase().trim().includes(src_string.toLowerCase().trim()))
        .filter(f => f.tag_type === tab_state && !selected_ids.includes(f.tag_id));

    console.log(192, 'filteredTags:', filteredTags);


    // Filter tags based on the search input and exclude selected tags
    // const filteredTags = tags.filter((tag) => tag.title.toLowerCase().includes(inputVal.toLowerCase())).filter((tag) => !selectedTags.includes(tag.id));

    // const noResultsFound = inputVal.length > 0 && filteredTags.length === 0;

    return (
        <>
            <div className="createRoomPopup !z-[50] animate__animated animate__zoomIn animation_duration bgSurfaceDark">
                <header className="filterFileHeader  ">
                    <div onClick={closePopup} className="allfilterFileHeader !items-center">
                        <MdArrowBackIos className="allFileHeaderIcon thread_eHeaderIcon text-2xl !-mt-0" />
                        <span className="allFileHeaderText !mt-0">Shared team tag(s)</span>
                    </div>
                    <div className="headTools">
                        <div className="allFileHeaderSearchMenu"></div>
                    </div>
                </header>
                <div className="tagModalBodys bgSurfaceDark">
                    {
                        tab_state === 'public' ?
                            <>
                                <div className={`tagAddSearch dark:bg-transparent !mt-3 ${tab_state}`}>
                                    <input
                                        className='dark:placeholder-white dark:text-white dark:bg-transparent'
                                        type="text"
                                        maxLength="25"
                                        value={src_string}
                                        onChange={(e) => setSrc_string(e.target.value)}
                                        placeholder='Search tag or create a new one'
                                    />
                                    {inputVal.length > 0 && (
                                        <span className="tagSearchCloseIcon" onClick={() => setInputVal('')}>
                                            <MdClose className='text-red-600 text-2xl' />
                                        </span>
                                    )}
                                </div>
                                <div className="selectedParticipants pt-3 pl-3 pr-3 tag_container_mini">
                                    {selected_ids.length > 0 &&
                                        all_tags?.filter(t => selected_ids.includes(t.tag_id)).map(v =>
                                            <div key={'__' + v.tag_id} className="flex mr-1 mb-1 gap-2 items-center rounded-full px-3 py-0.5 text-sm" style={{ backgroundColor: v.tag_color }}>
                                                <div className="text-white"><p>{v.title}</p></div>
                                                <div className="text-white" onClick={() => setSelected_ids(selected_ids.filter(f => f !== v.tag_id))}>
                                                    <MdOutlineClose />
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                                <div className="tagContainer !max-h-[470px] !min-h-96 overflow-y-auto">
                                    {loader ? (
                                        <div className="btn_loader !border-0 !h-[170px]"></div>
                                    ) : (
                                        filteredTags.length > 0 ? (
                                            filteredTags.map((v, i) => (
                                                <div className={`tagItem bgSurfaceDarkMainBox dark:border-none  ${tagEditInput === v.tag_id && 'editable_tag'}`} style={{ borderLeft: "6px solid", borderLeftColor: v.tag_color }} key={'_tags_' + i}>
                                                    {tagEditInput !== v.tag_id ? (
                                                        <p onClick={() => select_tag(v)} className={'tagTitle dark:text-white'}>{v.title}</p>
                                                    ) : (
                                                        <input
                                                            type="text"
                                                            className="tag_edit_input"
                                                            onChange={(e) => setEdit_title(e.target.value)}
                                                            onKeyUp={(e) => updateTagTitle(e, v)}
                                                            onBlur={() => { setEdit_title(''); setTagEditInput('') }}
                                                            defaultValue={v.title}
                                                            autoFocus
                                                        />
                                                    )}
                                                    {/* {v.title !== "PERSONAL FILES" && tab_state !== 'public' && (
                                                            <div className="tagHoverOptions">
                                                                <span onClick={() => { setEdit_title(v.title); setTagEditInput(tagEditInput === v.tag_id ? null : v.tag_id) }} className="tagOpt editTag dark"></span>
                                                                <span className="tagOpt deleteTag" onClick={() => delete_confirm(v.tag_id)}></span>
                                                            </div>
                                                        )} */}
                                                </div>
                                            ))
                                        ) : (
                                            <div className="no_tags_found flex justify-center mt-32 dark:text-white">No data found matching the criteria.</div>
                                        )
                                    )}
                                </div>
                                <div className="tagModalFoot !absolute !bottom-0 bgSurfaceDarkBox dark:border-none">
                                    <button className="btnAction !bg-white !border !border-teal-200 !text-teal-600" onClick={closePopup}>Cancel</button>
                                    {changesMade && <button className="btnAction" onClick={submit_tag}>{type === 'file' && (tag_list.length > 0 || active_file?.tag_list?.length > 0) ? 'Update' : 'Add'}</button>}

                                    {src_string !== '' && all_tags.filter(f => f.title.toLowerCase().trim() === src_string.toLowerCase().trim()).length === 0 && (
                                        <button className="btnAction 77" onClick={() => setCreateTagsPopup(true)}>Create tag</button>
                                    )}
                                </div>
                            </>
                            : <PersonalTags />
                    }
                </div>
            </div>
            <CreateTag isOpen={createTagsPopup} onClose={setCreateTagsPopup} all_tags={all_tags} setAll_tags={setAll_tags} search={src_string} setSearch={setSrc_string} select_tag={select_tag} />
        </>
    );
};

export default TagsPopup;
